import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

import FeatureCard from './FeatureCard'
import { guarantee, skylightPromise, support, families } from './consumerConConstants'
import { Container, Header, ContentContainer, FeaturesContainer } from './styles'
import { LOCALIZATION_MAP, LOCALIZATION } from '../../utils/constants'

const { AU, CA, UK, US } = LOCALIZATION_MAP

const ConsumerConfidence = () => {
  const { guaranteeIcon, skylightPromiseIcon, supportIcon, skylightFamiliesIcon } =
    useStaticQuery(graphql`
      query ConsumerConfidenceQuery {
        guaranteeIcon: file(relativePath: { eq: "consumerConfidence/4-months-free-no-copy.png" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        skylightPromiseIcon: file(
          relativePath: { eq: "consumerConfidence/skylight-promise-icon.png" }
        ) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        supportIcon: file(relativePath: { eq: "consumerConfidence/support-icon.png" }) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
        skylightFamiliesIcon: file(
          relativePath: { eq: "consumerConfidence/skylight-families-icon.png" }
        ) {
          childImageSharp {
            gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
          }
        }
      }
    `)

  const iconMap = {
    [guarantee.title]: guaranteeIcon,
    [skylightPromise.title]: skylightPromiseIcon,
    [support.title]: supportIcon,
    [families.title]: skylightFamiliesIcon,
  }

  const itemsForAllInternational = [guarantee, families, support]

  const localizedItems = {
    [AU]: itemsForAllInternational,
    [CA]: itemsForAllInternational,
    [UK]: itemsForAllInternational,
    [US]: [guarantee, skylightPromise, support],
  }

  // A fall back for random sites in edge case testing
  const features = localizedItems[LOCALIZATION] ? localizedItems[LOCALIZATION] : localizedItems[US]

  const featureItems = features.map((item, idx) => (
    <FeatureCard
      key={`${item.title}-${idx}`}
      icon={
        <GatsbyImage image={iconMap[item.title].childImageSharp.gatsbyImageData} alt={item.title} />
      }
      title={item.title}
      copy={item.copy}
      linkCopy={item.linkCopy}
      linkUrl={item.linkUrl}
    />
  ))

  return (
    <>
      <Container>
        <ContentContainer>
          <Header>Included with Purchase</Header>
          <FeaturesContainer>{featureItems}</FeaturesContainer>
        </ContentContainer>
      </Container>
    </>
  )
}

export default ConsumerConfidence
